<template>
    <div class="search__page">
        <div class="search__input">
            <input placeholder="Search..." type="text" v-model="searchValue" name="search__value">
        </div>
        <div class="search__result">
            <p v-if="searchValue" >Résult de votre recherche pour {{searchValue}}</p>

            <ProductsGrid v-if="searchValue" :productsArray="filteredShop" type="movie" :addvisible='true'/>
            <span v-else >
                <input type="checkbox" id="popular"  v-on:click="setPopularMovie(popular,$event)">
                <label for="popular">Movie Popular</label>
                <input type="checkbox" id="upComming"  v-on:click="setUpCommingMovie(upComming,$event)">
                <label for="upComming">Movie UpComming</label>
                <input type="checkbox" id="topRated"  v-on:click="setTopRatedMovie(topRated,$event)">
                <label for="topRated">Movie Top Rated</label>
                <input type="checkbox" id="topRatedTv"  v-on:click="setTopRatedTv(topRatedTv,$event)">
                <label for="topRatedTv">TV Top Rated</label>
                <input type="checkbox" id="popularTv"  v-on:click="setPopularTv(popularTv,$event)">
                <label for="popularTv">TV Popular</label>
                <br>

		        <ProductsGrid  v-if="popular" :productsArray="moviesListPopular" type="movie" :addvisible="true"/>
		        <ProductsGrid  v-if="upComming" :productsArray="moviesListUpComing" type="movie" :addvisible="true"/>
		        <ProductsGrid  v-if="topRated" :productsArray="moviesListTop" type="movie" :addvisible="true"/>
		        <ProductsGrid  v-if="topRatedTv" :productsArray="tvListTop" type="tv" :addvisible="true"/>
		        <ProductsGrid  v-if="popularTv" :productsArray="tvListPopular" type="tv" :addvisible="true"/>

            </span>
            <span v-if="searchValue && filteredShop.length ===0" >Aucun film trouvé</span>


            
        </div>
    </div>
</template>

<script>
    import ApiProducts from "@/mixins/ApiProducts";
    import ProductsGrid from "../components/ProductsGrid"
    import Carousel from "@/components/Carousel";
    import {Carousel3d, Slide} from 'vue-carousel-3d';


    export default {
        data: function() {
            return {
                productsList:[],
                moviesListTop: [],
                moviesListPopular: [],
                moviesListUpComing: [],
                tvListTop: [],
                tvListPopular: [],
                searchValue:"",
                searchLabel:"",
                checkedNames: [],
                popular:false,
                topRated:false,
                upComming:false,
                topRatedTv:false,
                popularTv:false,
            }
        },
        components: {
            ProductsGrid,
            Carousel3d,
            Slide,
            Carousel
        },
        methods: {
            searchMovies(name){
                this.getMovies(name)
                        .then(data => {
                            if(data){
                                this.productsList = data
                            }
                            else{this.productsList.push(data)}
                        })
                        .catch(err => console.log(err));
            },
            setPopularMovie(popular,event){
                if (event.target.checked) {
                    this.popular = true
                }else{
                    this.popular = false
                }
                return popular
            },
            setPopularTv(popularTv,event){
                if (event.target.checked) {
                    this.popularTv = true
                }else{
                    this.popularTv = false
                }
                return popularTv
            },
            setTopRatedMovie(topRated,event){
                if (event.target.checked) {
                    this.topRated = true
                }else{
                    this.topRated = false
                }
                return topRated
            },
            setTopRatedTv(topRatedTv,event){
                if (event.target.checked) {
                    this.topRatedTv = true
                }else{
                    this.topRatedTv = false
                }
                return topRatedTv
            },
            setUpCommingMovie(upComming,event){
                if (event.target.checked) {
                    this.upComming = true
                }else{
                    this.upComming = false
                }
                return upComming
            },

        },
        mounted() {
            this.getMoviesTopRated()
                .then(data => {
                    if (data) {
                        this.moviesListTop = data
                    } else {
                        this.moviesListTop.push(data)
                    }
                })
                .catch(err => console.log(err));

            this.getMoviesPopular()
                .then(data => {
                    if (data) {
                        this.moviesListPopular = data
                    } else {
                        this.moviesListPopular.push(data)
                    }
                })
                .catch(err => console.log(err));

            this.getMoviesUpComing()
                .then(data => {
                    if (data) {
                        this.moviesListUpComing = data
                    } else {
                        this.moviesListUpComing.push(data)
                    }
                })
                .catch(err => console.log(err));

            this.getTvTopRated()
                .then(data => {
                    if (data) {
                        this.tvListTop = data
                    } else {
                        this.tvListTop.push(data)
                    }
                })
                .catch(err => console.log(err));

            this.getTvPopular()
                .then(data => {
                    if (data) {
                        this.tvListPopular = data
                    } else {
                        this.tvListPopular.push(data)
                    }
                })
                .catch(err => console.log(err));
        },
        computed: {
            filteredShop: function() {
                let filter = new RegExp(this.searchValue,'i');
                return this.productsList.filter(item=>item.title.match(filter));
            }
        },
        watch: {
            searchValue: function(newValue, oldValue) {
                this.searchLabel=oldValue
                this.searchMovies(newValue)
            }
        },
        mixins:[ApiProducts]
    }
</script>

<style lang="scss" scoped>
.search__page{
    padding: 3%;

    .search__input{
        width: fit-content;
        margin: 0 auto 50px auto;

        input{
            padding: 20px;
            width: 300px;
            border-radius: 25px;
        }
    }

    p,label,h2{
        color: #fff;
    }

    input[type='checkbox']{
        margin: 0 5px 0 18px;
    }
    
    height: 75vh;
    overflow-x: auto;
}

.search__page::-webkit-scrollbar {
    margin:20px;
    width: 5px;
    background: #888;
    border-radius:10px;
}
.search__page::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius:10px;
    
}
</style>